// facets.js
class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();

    this.debouncedSubmit = this.debounce(this.onSubmitHandler.bind(this), 400);

    const form = this.querySelector('form');
    if (form) {
      // Listen for checkbox/select changes
      form.addEventListener('change', this.debouncedSubmit);
      // Prevent default full-page submit
      form.addEventListener('submit', (e) => e.preventDefault());
    }

    // Global listeners
    document.addEventListener('click', (e) => this.onPaginationClick(e));
    window.addEventListener('popstate', () => this.onHistoryChange());
  }

  debounce(fn, delay) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), delay);
    };
  }

  onSubmitHandler(e) {
    const form = e.target.closest('form');
    if (!form) return;
    const params = new URLSearchParams(new FormData(form)).toString();
    const url = `${window.location.pathname}?${params}`;
    this.renderPage(url);
  }

  onPaginationClick(e) {
    const link = e.target.closest('.pagination a');
    if (!link) return;
    e.preventDefault();

    // 🟢 store sidebar open state BEFORE reload
    const sidebar = document.getElementById('CollectionSidebar');
    const overlay = document.getElementById('CollectionOverlay');
    const sidebarWasOpen = sidebar?.classList.contains('active');

  // then pass it to renderPage()
  this.renderPage(url, true, sidebarWasOpen);

    
  }

  onHistoryChange() {
    this.renderPage(window.location.href, false);
  }

  getSectionId() {
    const el = document.querySelector('[id^="shopify-section-template"][id$="__main"]');
    return el ? el.id.replace('shopify-section-', '') : 'main';
  }

  renderPage(url, updateHistory = true) {
    const sectionId = this.getSectionId();
    const sectionUrl = url.includes('?')
      ? `${url}&sections=${sectionId}`
      : `${url}?sections=${sectionId}`;

    fetch(sectionUrl)
      .then((res) => res.json())
      .then((data) => {
        const html = new DOMParser().parseFromString(data[sectionId], 'text/html');
        const newSection = html.querySelector(`[id^="shopify-section-template"][id$="__main"]`);
        const current = document.querySelector(`[id^="shopify-section-template"][id$="__main"]`);

        if (newSection && current) {
          current.replaceWith(newSection);
          window.scrollTo({ top: 0, behavior: 'smooth' });

          // 🟢 Rebind infinite scroll after AJAX update
          if (typeof initInfiniteScroll === 'function') initInfiniteScroll();

          // 🟢 Rebind pagination click events (new links)
          document.addEventListener('click', (e) => this.onPaginationClick(e));

          // ⭐⭐⭐ AFTER AJAX RELOAD → REBUILD THE RING SIZE SLIDER
          if (typeof initRingSizeSlider === 'function') initRingSizeSlider();
        

        }
        // 🟢 restore sidebar open state if it was open before
        if (sidebarWasOpen) {
          const sidebar = document.getElementById('CollectionSidebar');
          const overlay = document.getElementById('CollectionOverlay');
          sidebar?.classList.add('active');
          overlay?.classList.add('active');
        }
        if (updateHistory) window.history.pushState({ filters: true }, '', url);
      })
      .catch((err) => console.error('Filter render error:', err));
  }
}

customElements.define('facet-filters-form', FacetFiltersForm);
